module.exports = ".background {\n  background-color: #114B5F;\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.background > .wrapper {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n}\n\n.background > .wrapper > .spinner {\n  margin: 100px auto;\n  width: 80px;\n  height: 80px;\n  position: relative;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/loading/loading.component.css
// module id = ./src/app/auth/loading/loading.component.css
// module chunks = main